import React from 'react';
import { FormattedMessage } from 'react-intl';
import { EventStatus } from '../../../../../api/events.dao';
import { IProgressItem, ProgressBar } from './progress-bar';

interface IProps {
    status: EventStatus;
    changeStatus: (e) => void;
    disabled?: boolean;
}

const EventProgressBar = (props: IProps) => {

    const { status, changeStatus, disabled = false } = props;

    const statusKey = (statusName: EventStatus) => {
        return Object.values(EventStatus).indexOf(statusName);
    };

    const activeItem = (progressType: EventStatus) => statusKey(status) >= statusKey(progressType) && !disabled;
    const disabledItem = (progressType: EventStatus) => statusKey(status) > statusKey(progressType) && !disabled;

    const progressBarFields: IProgressItem[] = [
        {
            type: 'Step',
            status: EventStatus.IN_PROGRESS,
            active: activeItem(EventStatus.IN_PROGRESS),
            disabled: disabledItem(EventStatus.IN_PROGRESS),
            default: true,
            label: <FormattedMessage
                id='oe.common.in_progress'
                defaultMessage='In Progress'
                description='In Progress label text'
            />
        },
        {
            type: 'Line',
            active: activeItem(EventStatus.DELIVERED),
        },
        {
            type: 'Step',
            status: EventStatus.DELIVERED,
            active: activeItem(EventStatus.DELIVERED),
            disabled: disabledItem(EventStatus.DELIVERED),
            label: <FormattedMessage
                id='oe.common.delivered'
                defaultMessage='Delivered'
                description='Delivered label text'
            />
        }
    ];

    const handleClick = e => {
        if (e.currentTarget.dataset.default) return;
        if (e.currentTarget.dataset.value === status) {
            changeStatus(Object.values(EventStatus)[statusKey(status) - 1]);
        } else {
            changeStatus(e.currentTarget.dataset.value);
        }

    };

    return (
        <ProgressBar
            progressBarFields={progressBarFields}
            handleClick={handleClick}
            disabled={disabled}
        />
    );
};

export { EventProgressBar };
